<script lang="ts">
	import type { ButtonProps } from "./ButtonProps.js";
	import { generateButtonClasses } from "./ButtonClasses.js";
	import Icon from "./Icon.svelte";
	import ButtonIcon from "./ButtonIcon.svelte";

	type $$Props = ButtonProps;

	$: ({
		active = false,
		icon,
		iconFront = false,
		iconClass,
		iconGap = "mr-5",
		disabled = false,
		variant = "primary",
		...restProps
	} = $$restProps as $$Props);

	$: type = restProps.type ?? "button";
	$: btnClasses = [restProps.class, generateButtonClasses({ variant, disabled, active })].filter(Boolean).join(" ");
</script>

<button {...restProps} class={btnClasses} {type} {disabled} on:click on:mousedown>
	{#if icon && iconFront}
		<Icon {icon} class=" z-10 max-w-9 {disabled ? 'text-ltsecondary-300' : ''} {iconClass}" />
	{/if}

	<span class="z-10 {icon ? iconGap : ''}">
		<slot />
	</span>

	{#if icon && !iconFront}
		<ButtonIcon {icon} {disabled} {iconClass} {variant} />
	{/if}
</button>
